/** World coordinate constants (Architecture §6). M0 stub. */
export const WORLD_WIDTH = 1080;
export const SURFACE_HEIGHT = 640;
export const SHAFT_ROW_HEIGHT = 280;
